/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RoleDto } from './roleDto';


export interface RoleDtoPagedResultDto { 
    items?: Array<RoleDto> | null;
    totalCount?: number;
}

